module.exports = __webpack_public_path__ + "static/media/correct_icon.fb5ad2a4.svg";